<!-- components/GuestBillingInfo.vue -->
<template>
  <BModal
    id="modal-tall"
    :model-value="modalDetail"
    scrollable
    centered
    title="CheckoutDetail"
    @update:modelValue="updateModal"
  >
    <template #header>
      <div
        class="d-flex align-items-center justify-content-between modal-title w-100"
      >
        <h5 class="">CheckOut Information</h5>
        <!-- <div class="d-flex align-items-center">
          <span class="mr-2">17/02/2025 16:00:00</span>
          <div class="bg-success rounded-circle" style="width: 10px; height: 10px;"></div>
          <span>online: Ruth</span>
        </div> -->
      </div>
      <BButton variant="link" class="close" @click="updateModal(false)">
        <i class="ion ion-android-close"></i>
      </BButton>
    </template>

    <div class="guest-info text-start" id="printArea">
      <!--  Kop & logo (print)  -->
      <div class="print-only" style="text-align: center; margin: 0; padding: 0">
        <table
          class="w-full border-collapse"
          style="width: 100%; border-collapse: collapse"
        >
          <tbody style="padding: 0; margin: 0">
            <tr class="border-b border-transparent">
              <td class="text-center" style="text-align: center">
                <img
                  src="../../../public/img/hotel-deliriver.png"
                  alt="Deli River Hotel Logo"
                  style="width: 50px; height: auto"
                />
              </td>
            </tr>
            <tr
              class="border-b border-transparent"
              style="padding: 0px; margin: 0px"
            >
              <td class="text-center">
                <h3 class="text-center">Deli River Hotel</h3>
                <p class="text-center">
                  Jl. Raya Namorambe No. 129, Medan, Indonesia
                </p>
                <p class="text-center">www.hotel-deliriver.com</p>
                <p class="text-center">contact@hotel-deliriver.com</p>
              </td>
            </tr>
          </tbody>
        </table>
        <hr />
      </div>

      <h4 class="print-only text-align-center">CheckOut Preview</h4>

      <div>
        <p class="text-secondary fw-semibold">Guest Information</p>
        <table class="w-full text-left border-collapse">
          <tbody>
            <tr class="border-b border-transparent">
              <td class="text-left">Res. Number</td>
              <td class="text-left">:</td>
              <td class="text-left fw-semibold">
                {{ data?.reservation?.number ?? "-" }}
              </td>
            </tr>
            <tr class="border-b border-transparent">
              <td class="text-left">Name</td>
              <td class="text-left">:</td>
              <td class="text-left fw-semibold">
                {{ data?.reservation?.guest?.fullname ?? "-" }}
              </td>
            </tr>
            <!-- <tr class="screen-only border-b border-transparent">
              <td class="text-left">Contact</td>
              <td class="text-left">:</td>
              <td class="text-left fw-semibold">
                0{{ data?.reservation?.guest?.phone ?? "-" }}
              </td>
            </tr> -->
            <tr class="border-b border-transparent">
              <td class="text-left">Check In</td>
              <td class="text-left">:</td>
              <td class="text-left fw-semibold">
                {{ dateFormatter(data?.check_in_date) }}
              </td>
            </tr>
            <tr class="border-b border-transparent">
              <td class="text-left">Check Out</td>
              <td class="text-left">:</td>
              <td class="text-left fw-semibold">
                {{ dateFormatter(data?.check_out_date) }}
              </td>
            </tr>
            <tr class="border-b border-transparent">
              <td class="text-left">Stay Duration</td>
              <td class="text-left">:</td>
              <td class="text-left fw-semibold">
                {{ countDays(data?.check_in_date, data?.check_out_date) }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <br />
      <div>
        <p class="text-secondary fw-semibold billing-detail">Billing Detail</p>
        <table class="w-full text-left border-collapse table-billing">
          <tbody>
            <tr class="border-b border-transparent">
              <td class="text-left">Room Type</td>
              <td class="text-left">:</td>
              <td class="text-left fw-semibold">
                {{ data?.reservation?.room?.room_category?.name ?? "-" }}
              </td>
            </tr>
            <tr class="border-b border-transparent">
              <td class="text-left">Room Number</td>
              <td class="text-left">:</td>
              <td class="text-left fw-semibold">
                {{ data?.reservation?.room?.code ?? "-" }}
              </td>
            </tr>
            <!-- //comment dulu karna pencocokan harga kamar normal & highseason -->
            <!-- <tr class="border-b border-transparent">
              <td class="text-left">Room Rate</td>
              <td class="text-left">:</td>
              <td class="text-left fw-semibold">
                {{
                  formatIDR(
                    data?.reservation?.room?.room_category?.low_season_price ??
                      0
                  )
                }}
              </td>
            </tr> -->

            <!-- Extra Charge -->
            <tr class="border-b border-transparent align-top">
              <td class="text-left">Extra Charge</td>
              <td class="text-left">:</td>
              <td class="text-left fw-semibold">
                <div v-if="!data?.reservation?.extracharge?.length">-</div>
                <div
                  v-else
                  v-for="(item, index) in data?.reservation?.extracharge"
                  :key="index"
                >
                  {{ item.extra_charge?.name }} (Qty: {{ item.quantity }},
                  {{ formatIDR(item?.price ?? 0) }})
                </div>
              </td>
            </tr>

            <!-- Payments -->
            <tr class="border-b border-transparent align-top">
              <td class="text-left">Payment</td>
              <td class="text-left">:</td>
              <td class="text-left fw-semibold">
                <div v-if="!data?.reservation?.payment?.length">-</div>
                <div
                  v-else
                  v-for="(item, index) in data?.reservation?.payment"
                  :key="index"
                >
                  {{ item.payment_type }}
                  ({{ formatIDR(item.amount ?? 0) }} at
                  {{ getFormattedDate(item.payment_date) }})
                </div>
              </td>
            </tr>

            <tr class="border-b border-transparent">
              <td class="text-left">Pending Bill</td>
              <td class="text-left">:</td>
              <td class="text-left fw-semibold">
                {{ formatIDR(data?.reservation?.outstanding_balance ?? 0) }}
              </td>
            </tr>
            <tr class="border-b border-transparent">
              <td class="text-left">Total</td>
              <td class="text-left">:</td>
              <td class="text-left fw-semibold">
                {{ formatIDR(data?.reservation?.total_paid ?? 0) }}
              </td>
            </tr>
            <tr class="border-b border-transparent">
              <td class="text-left">Status</td>
              <td class="text-left">:</td>
              <td class="text-left fw-semibold">
                {{ data?.reservation?.payment_status ?? "-" }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <br />
      <!--  Tanda tangan (print) -->
      <!-- <div class="print-only mt-8" style="display:flex;justify-content:space-between;">
        <div>
          <p>Medan, {{ new Date().toLocaleDateString('id-ID') }}</p>
          <p><strong>Petugas Resepsionis</strong></p><br><br>
          <p>______________________</p>
        </div>
        <div>
          <p>&nbsp;</p>
          <p><strong>Tamu</strong></p><br><br>
          <p>______________________</p>
        </div>
      </div> -->
    </div>

    <template #footer>
      <div class="d-flex justify-content-end">
        <!-- Tombol cetak muncul hanya jika modal detail aktif -->
        <BButton variant="warning" class="mr-2" @click="handlePrint"
          >Print</BButton
        >

        <!-- <BButton variant="primary" @click="submitReservation"  class="mr-2">Save</BButton> -->
        <BButton variant="danger" @click="updateModal(false)">Close</BButton>
      </div>
    </template>
  </BModal>
</template>

<script>
//   defineProps({
//     data: Object,
//   })
import { formatIDR } from "@/utils/currency";
import { dateFormatter } from "@/utils/dateFormatter";
import { countDays } from "@/utils/dateCalculation";
import { getFormattedDate } from "@/composable/getDateTimeFormatter";

import {
  BModal,
  BButton,
  // BRow,
  // BCol,
  // BForm,
  // BTabs,
  // BTab,
  // BFormInput,
  // BFormSelect,
  // BFormSelectOption,
  // BInputGroup,
  // BListGroup,
  // BListGroupItem,
  // BFormTextarea,
  // BFormRadioGroup
} from "bootstrap-vue-next";

export default {
  name: "CheckOutDetail",
  components: {
    BModal,
    BButton,
    // BRow,
    // BCol,
    // BForm,
    // BTabs,
    // BTab,
    // BFormInput,
    // BFormSelect,
    // BFormSelectOption,
    // BInputGroup,
    // BButton,
    // BListGroup,
    // BListGroupItem,
    // BFormTextarea,
    // BFormRadioGroup
  },

  props: {
    modal: Boolean,
    data: Object,
    title: { type: String, default: "Detail" },
    //modelValue:  { type: Boolean, default: false },
  },

  emits: ["update:modal", "update:modelValue"],

  setup(props, { emit }) {
    const updateModal = (value) => {
      emit("update:modal", value); // Sync modal state with parent
    };

    return {
      formatIDR,
      dateFormatter,
      countDays,
      getFormattedDate,
      updateModal,
    };
  },

  methods: {
    handlePrint() {
      this.$nextTick(() => {
        const printContents = document.getElementById("printArea").innerHTML;
        //const printWindow = window.open("", "", "width=80,height=auto");

        const now = new Date();
        const pad = (num) => String(num).padStart(2, "0");
        const formattedDate = `${now.getFullYear()}-${pad(
          now.getMonth() + 1
        )}-${pad(now.getDate())}_${pad(now.getHours())}-${pad(
          now.getMinutes()
        )}-${pad(now.getSeconds())}`;
        const filename = `RECEIPT-deli-river-hotel-${formattedDate}`;

        // Penambahan buat iframe tersembunyi
        const iframe = document.createElement("iframe");
        iframe.style.position = "fixed";
        iframe.style.right = "0";
        iframe.style.bottom = "0";
        iframe.style.width = "0";
        iframe.style.height = "0";
        iframe.style.border = "0";
        iframe.setAttribute(
          "sandbox",
          "allow-modals allow-same-origin allow-scripts"
        );
        document.body.appendChild(iframe);

        const doc = iframe.contentDocument || iframe.contentWindow.document;

        // const htmlTemplate =`
        //   <!DOCTYPE html>
        //   <html>
        //     <head>
        //       <title>${filename}</title>
        //       <meta name="viewport" content="width=device-width,initial-scale=1.0">
        //       <style>
        //         @media print
        //         {
                  
        //           @page {
        //             size: 80mm auto;    
        //           }
        //           body {
        //             font-family: sans-serif;
        //             font-size: 8px;
        //             margin: 10px;
        //             padding: 0;
        //           }
        //           h2 {
        //             font-size: 10px;
        //             margin: 0;
        //           }
        //           h3 {
        //             margin: 0;
        //           }
        //           h4 {
        //             margin: 0;
        //           }
        //           p {
        //             margin: 3px 0px;
        //           }
        //           .billing-detail {
        //             margin-top: -5px;
        //           }
        //           hr {
        //             margin-top: -5px;
        //           }
        //           tbody {
        //             margin: 0px;
        //           }
        //         }
        //       </style>
        //     </head>
        //     <body>
        //       ${printContents}
        //     </body>
        //   </html>
        // `;

        // printWindow.document.write(htmlTemplate);
        // printWindow.document.close();
        // printWindow.focus();

        // setTimeout(() => {
        //   printWindow.print();
        //   printWindow.close();
        // }, 1000);

        doc.open();
        doc.write(`
          <!DOCTYPE html>
          <html>
            <head>
              <title>${filename}</title>
              <meta name="viewport" content="width=device-width,initial-scale=1.0">
              <style>
                @media print
                {
                  
                  @page {
                    size: 80mm auto;    
                  }
                  body {
                    font-family: "Consolas", monospace;
                    font-weight: bold;
                    font-size: 14px;
                    margin: 10px;
                    padding: 0;
                  }
                  h2 {
                    font-size: 10px;
                    margin: 0;
                  }
                  h3 {
                    margin: 0;
                  }
                  h4 {
                    margin: 0;
                  }
                  p {
                    margin: 3px 0px;
                  }
                  .billing-detail {
                    margin-top: -5px;
                  }
                  hr {
                    margin-top: -5px;
                  }
                  tbody {
                    margin: 0px;
                  }
                }
              </style>
            </head>
            <body>
              ${printContents}
            </body>
          </html>
        `);
        doc.close();

        // Tunggu iframe selesai load sebelum print
        iframe.onload = () => {
          iframe.contentWindow.focus();
          iframe.contentWindow.print();

          // Bersihkan iframe setelah print
          setTimeout(() => {
            document.body.removeChild(iframe);
          }, 1000);
        };
      });
    },
  },
};
</script>

<style scoped>
/* style untuk print */
@media print {
  body * {
    visibility: hidden;
  }
  #printArea,
  #printArea * {
    visibility: visible;
  }
  #printArea {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
  }
  #printArea .situs {
    padding: 30px;
  }
  button {
    display: none !important;
  }
  .navbar,
  .footer,
  .btn {
    display: none;
  }

  .print-only {
    display: block !important;
  }
  .screen-only {
    display: none !important;
  }
}

/* Elemen hanya layar vs hanya print */
.print-only {
  display: none;
}
.screen-only {
  display: block;
}

.situs {
  padding: 20px;
  margin: 20px;
  color: red;
}
</style>
